import status from './status'
import gatetime from './gatetime'

const attendance = [
  {
    path: '/attendance/gatetime',
    component: () => import('@/page/attendance/Gatetime.vue'),
    redirect: '/attendance/gatetime/current',
    children: [
      ...gatetime
    ],
    meta: {
      name: '출퇴근 현황',
      isMenu: false,
      isActive: false,
      isBread: true
    }
  },
  {
    path: '/attendance/status',
    component: () => import('@/page/attendance/Status.vue'),
    redirect: '/attendance/status/month',
    children: [
      ...status
    ],
    meta: {
      name: '근태 현황',
      isMenu: false,
      isActive: false,
      isBread: true
    }
  },
]

export default attendance